import { SxProps } from "@mui/material";
import { IssueStatusChangedDialogContent, StatusPicker, useDialog } from "src/components";
import { ClosedIssueStatuses, DEFAULT_TASK_ITEM_STATUS, ISSUE_STATUSES, IssueStatus } from "src/constants";
import { useEditIssueStatus } from "src/http";
import { IssueProcessedDialogContent } from "./IssueProcessedDialogContent";

interface IProps {
  variant: "button" | "select";
  issueGuid?: string;
  status: IssueStatus;
  hasDecision: boolean;
  createdByUserGuid: string;
  teamSlug: string | undefined;
  disabled?: boolean;
  sx?: SxProps;
}

const IssueStatusPicker = (props: IProps) => {
  const { mutate: editIssueStatus } = useEditIssueStatus();
  const { showDialog, closeDialog } = useDialog();

  async function handleStatusChanged(newSelectedStatus: IssueStatus) {
    if (props.issueGuid === undefined || props.createdByUserGuid === undefined) {
      return;
    }

    switch (newSelectedStatus) {
      case IssueStatus.InProgress:
      case IssueStatus.Paused:
        showDialog({
          content: (
            <IssueStatusChangedDialogContent
              issueGuid={props.issueGuid}
              status={newSelectedStatus}
              hasDecision={props.hasDecision}
              onDone={closeDialog}
            />
          ),
        });
        break;
      case IssueStatus.Processed:
        showDialog({
          content: (
            <IssueProcessedDialogContent
              issueGuid={props.issueGuid}
              hasDecision={props.hasDecision}
              createdByUserGuid={props.createdByUserGuid}
              teamSlug={props.teamSlug}
              onDone={closeDialog}
            />
          ),
        });
        break;
    }

    await editIssueStatus({
      issueGuid: props.issueGuid,
      statusId: newSelectedStatus,
      teamSlug: props.teamSlug,
      createdByUserId: props.createdByUserGuid,
    });
  }

  return (
    <StatusPicker
      variant={props.variant}
      disabled={props.disabled}
      value={props.status ?? DEFAULT_TASK_ITEM_STATUS}
      options={ISSUE_STATUSES.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : 0))}
      groupBy={(option) => (ClosedIssueStatuses.includes(option.id) ? "Closed Statuses" : "Active Statuses")}
      onChange={handleStatusChanged}
      sx={{ ...props.sx }}
    />
  );
};

export { IssueStatusPicker };
